export default __webpack_public_path__ + "static/media/ic-event-purchase.c007c20d.svg";